import React, { useEffect, useState } from "react";
import { MyMoneyListItem, BtnMore } from "pages";

import { btn_more } from "styles/img";

import { numberWithCommas, cengoldAlert } from "lib/utils";

import SyrupHeader from "./header/SyrupHeader";
import MoneytreeHeader from "./header/MoneytreeHeader";
import OKInvHeader from "./header/OKInvHeader";
import { CengoldModal } from "../../components/CengoldModal";
import { useLocalStorage } from "../../lib/useLocalStorage";
import { STORAGE_KEY, SERVICE_CODE } from "../../constants";

const MyMoneyList = ({
  name,
  ocbPoint,
  profit,
  balance,
  currentPrice,
  handleClickBuyMove,
}) => {
  const [modal, setModal] = useState(false);
  const [serviceCode] = useLocalStorage(STORAGE_KEY.SERVICE_CODE);

  let pegDiffPrice = 0;
  let pesDiffPrice = 0;
  let totalBalance = 0;
  let totalAveBalance = 0;
  let rate = 0.0;
  let rateClassName = "per";
  let rateOp = "   ";
  if (profit) {
    pegDiffPrice = profit.peg.currentPrice - profit.peg.gainAverage;
    pesDiffPrice = profit.pes.currentPrice - profit.pes.gainAverage;
    totalBalance = (
      profit.peg.currentPrice * balance.peg +
        profit.pes.currentPrice * balance.pes || 0
    ).toFixed(0);

    totalAveBalance = (
      profit.peg.gainAverage * balance.peg +
        profit.pes.gainAverage * balance.pes || 0
    ).toFixed(0);
    rate = (
      ((totalBalance - totalAveBalance) / totalAveBalance) * 100 || 0
    ).toFixed(2);

    if (rate > 0) {
      rateClassName += " plus";
      rateOp = " + ";
    } else if (rate < 0) {
      rateClassName += " minus";
      rateOp = " - ";
    }
  }

  let header = {};
  let contentClass = "content";

  if (serviceCode === SERVICE_CODE.SYRUP) {
    header = <SyrupHeader name={name} point={ocbPoint} />;
  } else if (serviceCode === SERVICE_CODE.MONEYTREE) {
    header = <MoneytreeHeader point={ocbPoint} />;
    contentClass = "content product_moneytree";
  } else if (serviceCode === SERVICE_CODE.OKINV) {
    header = <OKInvHeader point={ocbPoint} />;
    contentClass = "content product_ok";
  }

  const hideModal = () => {
    setModal(false);
  };

  return (
    <div className="section bg_gr">
      <div className={contentClass}>
        {header}
        <div className="my_money">
          <p className="tt1">자산 평가금액</p>
          <p className="tt2">
            {numberWithCommas(totalBalance)} <span className="krw">KRW</span>
          </p>
          <p className="tt3">
            수익률{" "}
            <span className={rateClassName}>
              {rateOp}
              {Math.abs(rate)}%
            </span>
          </p>
        </div>
        <div className="e_wrap">
          <ul>
            <MyMoneyListItem
              name={"e금"}
              balance={balance?.peg}
              currentPrice={currentPrice?.pegPrice}
              diffPrice={pegDiffPrice}
              handleClickBuyMove={() => {
                handleClickBuyMove("peg");
              }}
            />
            <MyMoneyListItem
              name={"e은"}
              balance={balance?.pes}
              currentPrice={currentPrice?.pesPrice}
              diffPrice={pesDiffPrice}
              handleClickBuyMove={() => {
                handleClickBuyMove("pes");
              }}
            />
          </ul>
          <BtnMore
            className="btn_more apply_btn2"
            txt="비단 바로가기"
            imgSrc={btn_more}
            onClick={() => {
              setModal(true);
            }}
          />
        </div>
      </div>
      <CengoldModal
        visible={modal}
        title={"비단 앱 바로가기"}
        onClose={hideModal}
      >
        <div>비단 앱에서 더욱 다양한 서비스를</div>
        <div>이용하실 수 있습니다.</div>
      </CengoldModal>
    </div>
  );
};

export default MyMoneyList;
